export const getItem = (
  key: string,
  fallback?: string,
  fromSession = false
) => {
  const fullKey = `nftx.${key}`;
  try {
    if (fromSession) return sessionStorage.getItem(fullKey) || fallback;
    else return localStorage.getItem(fullKey) || fallback;
  } catch {
    return fallback;
  }
};
